import {GetLoadables} from './loader'

// #if process.env.UIX_CHUNKED === 'true'
let loader = () => {
  return import(/* webpackChunkName: 'rtable' */ './rtableLoad')
}
const L = GetLoadables(loader, ['ReactTable'])
// #endif

// #if process.env.UIX_CHUNKED === 'false'
// import * as L from './rtableLoad'
// #endif

export let {ReactTable} = L
